export const NOTIFICATION_AREAS = [
  'HR',
  'Credentialing',
  'General',
  'Authorization Management',
  'Payroll',
  'Background Checks',
  'Calendar',
  'Staffing',
  'Professional Development',
  'Time Entry',
  'E-Sign',
  'Health Insurance Details',
  'Client Documentation',
] as const;

export type NotificationArea = typeof NOTIFICATION_AREAS[number];
